import { render, staticRenderFns } from "./provincia-form.vue?vue&type=template&id=8b54fce2&scoped=true"
import script from "./provincia-form.vue?vue&type=script&lang=js"
export * from "./provincia-form.vue?vue&type=script&lang=js"
import style0 from "./provincia-form.vue?vue&type=style&index=0&id=8b54fce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b54fce2",
  null
  
)

export default component.exports